import { useContext, useState } from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Drawer from "@mui/material/Drawer";
import DrawerMandate from "./DrawerMandate";
import { useGetMandateById } from "../../Hooks/useGetMandateById";
import { AuthContext } from "../../Context/AuthContext";
import { getKhmerNumber } from "../../Function/DynamicFn";

const getMandateId = () => {
  return window.localStorage.getItem("mandate_id") || "";
};

export default function SwitchMandate() {
  const { t, language } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const id = getMandateId();
  const { mandateData } = useGetMandateById({ id });
  const level = language === "kh" ? "ទី" : "";

  const mandate =
    language === "kh"
      ? getKhmerNumber(parseFloat(mandateData?.mandateName))
      : mandateData?.mandateName;
  return (
    <Stack direction="row" spacing={1}>
      <Chip
        label={t("thead_mandate") + level + mandate || ""}
        onClick={toggleDrawer(true)}
        deleteIcon={<KeyboardArrowDownIcon />}
        onDelete={toggleDrawer(true)}
        sx={{
          height: 35,
          borderRadius: "24px", // 👈 custom border radius
          "& .MuiChip-label": {
            fontSize: "0.9rem",
            padding: "0 8px 0 12px",
          },
        }}
      />

      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <DrawerMandate toggleDrawer={toggleDrawer} />
      </Drawer>
    </Stack>
  );
}
